import { HttpClient } from '@angular/common/http';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { VhQueryAutoWeb, VhImage, VhEventMediator } from 'vhautowebdb';
import { forkJoin } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject, Injectable } from '@angular/core';
import { FunctionService} from 'vhobjects-service/src/services';

@Component({
  selector: 'atw-frame-cart-products-config',
  templateUrl: './frame-cart-products-config.component.html',
  styleUrls: ['./frame-cart-products-config.component.scss'],
})
export class AtwFrameCartProductsConfig implements OnInit {
  @Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() device: any; // xác định device là desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any;@Input() type: any; // là dữ liệu desktop_config hoặc mobile_config từ database
  @Output() changeOptionConfig = new EventEmitter<any>();
  public isViewAll: boolean = false;
  public isCollapsed: boolean = false;
  public currentViewAll: any = {};
  // Xử lý chỉ mở được 1 menu 1 lần
  public openMenu: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
  };
  public urlBackgroundImage = ''; // Hình ảnh nền của frame (nếu có)
  public gapSpace = 0;
  public loadComplete = false;
  public stylesField = [
    {
      title: 'dieu_chinh_vien_khung',
      index: 1,
    },
    {
      title: 'dieu_chinh_vien_phan_tu',
      index: 2,
    },
  ];
  fonts: any = [];
  constructor(
    private vhQueryAutoWeb: VhQueryAutoWeb,
    private vhImage: VhImage,
    private matdialog: MatDialog,
    private vhEventMediator: VhEventMediator,
    private http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object,
    public functionService: FunctionService,
  ) { }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      if (!this.config.scrollbar) this.config.scrollbar = {
        "width_scrollbar": "0px",
        "height_scrollbar": "0px",
        "background_color_track": "#ffffff",
        "border_radius_track": "0px",
        "background_color_thumb": "#00a859",
        "border_radius_thumb": "0px"
      };

      if (this.class && this.config) {
        this.loadComplete = true;
        // Khoảng cách giữa cột và dòng
        this.gapSpace = parseInt(
          this.class['frame-cart-products__products']['gap'],
          10
        );
      }
      forkJoin([
        this.http.get('assets/fonts/fonts.json'),
      ]).subscribe(([fonts]: any) => {
        this.fonts = fonts;
      })
    }
  }



  openHandler(value: string): void {
    for (const key in this.openMenu) {
      if (key !== value) {
        this.openMenu[key] = false;
      }
    }
  }

  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  /** Hàm thực hiện kiểm tra điều kiện 1 hướng của viền và active option đấy nếu đủ điều kiện
   *
   * @param value
   */
  checkActiveDirectionBorder(value: any) {
    if (['0px', '0'].includes(value)) return false;
    return true;
  }


  updateObject() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_class']: this.class,
        [this.device + '_config']: this.config,
      })
      .then((bool: any) => {

      });
  }
  //Hàm update class
  updateClass() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_class']: this.class,
      })
      .then((bool: any) => {

      });
  }

  //Hàm update class
  updateConfig() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_config']: this.config,
      })
      .then((bool: any) => {

      });
  }

  updateStaticdata() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        staticdata: this.objectChoosing.staticdata,
      })
      .then((bool: any) => {

      });
  }



  handleChangeProd(event: any) {
    // cập nhật grid-auto-rows là cập nhật chiều cao của các sản phẩm vượt ra khỏi chiều cao của container
    this.class['frame-cart-products__products']['grid-auto-rows'] = `calc(100% / ${this.config['frame-cart-products__products'].rows}`;
    this.updateClass();
  }
  /**
  * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
  * @param event width hieght của element sau khi thay đổi
  */
  changeWidthHeight(event) {
    if (event.width) this.class['frame-cart-products']['width'] = event.width + 'px';
    if (event.height) this.class['frame-cart-products']['height'] = event.height + 'px';
    this.updateClass()
    this.vhEventMediator.notifyOnConfigChanged({ status: 'update-object-selected-ruler', code: this.objectChoosing._id });
  }
}
